
import { defineComponent } from "vue";

export default defineComponent({
  name: "custom-chat-loading"
});
